import { useTranslation } from "react-i18next";
import { Grid } from "semantic-ui-react";

import { formatPrice } from "utils/formatPrice";

import type { CustomerCommunicationIntervention, CustomerCommunicationReplacement } from "models";
import type { InclusiveUnion } from "utils/type";

type ResultItem = InclusiveUnion<CustomerCommunicationReplacement | CustomerCommunicationIntervention>;

type ServicesProps = {
  title: string;
  results?: ResultItem[] | null;
};

export const Services = ({ results, title }: ServicesProps) => {
  if (!results?.length) return null;

  const { t } = useTranslation();
  const { vat } = results[0];

  return (
    <div className="info-section">
      <div className="section-header">{title}</div>
      <div className="section-content">
        <Grid>
          <Grid.Column width={16}>
            <div className="services-header">
              <span>{t("v8_title", "Title")}</span>
              <span>{vat ? t("v8_price_inc_vat", "Price (incl. VAT)") : t("v8_price_excl_vat", "Price (excl. VAT)")}</span>
            </div>
            {results.map((result, key) => (
              <div className="service" key={key}>
                <div className="service-title-remark-container">
                  <span>{result.title ?? result.manufacturer + " " + result.reference}</span>
                </div>
                <div className="service-price-container">
                  <span>{vat && result.price ? formatPrice(Number((result.price * (1 + vat / 100)).toFixed(2))) : formatPrice(result.price)} €</span>
                </div>
              </div>
            ))}
          </Grid.Column>
        </Grid>
      </div>
    </div>
  );
};
